export const AccountType = Object.freeze({
    Customer: 1,
    Agent: 2,
    Employee: 3,
    Admin: 4
  });